import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardSidebar from '../../components/navigation/DashboardSidebar';
import DashboardHeader from '../../components/navigation/DashboardHeader';
import DashboardFooter from '../../components/navigation/DashboardFooter';
import MobileMenuButton from '../../components/navigation/MobileMenuButton';
import HeaderCreaAzienda from './components/HeaderCreaAzienda';
import NuovaAzienda from './components/NuovaAzienda'; // TVOJA NOVA KOMPONENTA

const CreaAzienda = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [userName] = useState('Marco Rossi');

  const handleLogout = () => {
    navigate('/landing-authentication');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-background">
      <MobileMenuButton isOpen={isSidebarOpen} onClick={toggleSidebar} />
      <DashboardSidebar
        isCollapsed={!isSidebarOpen}
        onToggle={toggleSidebar} 
      />

      <DashboardHeader
        onLogout={handleLogout}
        userName={userName} 
      />

      <main className="main-content with-sidebar">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
          
          <HeaderCreaAzienda userName={userName} />

          <div className="mt-8 max-w-4xl mx-auto">
            {/* FIKSNA KOMPONENTA UMJESTO MODALA */}
            <NuovaAzienda onSuccess={() => navigate('/home-dashboard-owner')} />
          </div>

        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default CreaAzienda;